export const locales = {
	downloadSuccess: 'Document téléchargé avec succès.'
};
